module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-44.9f73734f.jpg";